import { API } from './axiosInstance'

export const getSeoMeta = () =>
  API.get('/seo-params').then(res => res.data)